module.exports = __webpack_public_path__ + "img/img18.20ad5487.png";